import { createFileRoute } from '@tanstack/react-router'
import NotificationSettings from '@/pages/settings/notifications'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/notifications'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <NotificationSettings />
}
